import { createContext, useContext } from "react";

interface PageViewProperties {
  pageViewId: string | null;
}

const initialPageViewProperties: PageViewProperties = {
  pageViewId: null,
};

export const PageViewPropertiesContext = createContext<PageViewProperties>(
  initialPageViewProperties,
);
PageViewPropertiesContext.displayName = "AnalyticsPageViewPropertiesContext";

export const usePageViewPropertiesContext = () =>
  useContext(PageViewPropertiesContext);
